var prodcat = prodcat || '';
var site = site || '';
var MantleReviews = MantleReviews || {};
var MantleBehavior = MantleBehavior || {};
var drupalPRSettings = Drupal.settings.analytics
  ? Drupal.settings.analytics.power_reviews_enh_enabled
  : false;

(function ($) {
  /*
   * Move analytics attachment out of code.
   */
  var _attachReviewsAnalytics = function () {
    // Track thumbs up rating for a review
    $(document).on('click', '.pr-helpful-yes', function () {
      if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
        var obj = {
          event_action: 'thumbs up'
        };

        site.track.rateReviews(obj);
      }
    });

    // Track thumbs down  rating for a review
    $(document).on('click', '.pr-helpful-no', function () {
      if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
        var obj = {
          event_action: 'thumbs down'
        };

        site.track.rateReviews(obj);
      }
    });

    // Track flagging reviews in review page
    $(document).on(
      'click',
      '.pr-rd-flag-review-container .pr-underline, .pr-flag-review-btn-submit',
      function () {
        if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
          var obj = {
            event_action: 'flag this review'
          };

          site.track.rateReviews(obj);
        }
      }
    );

    // Tracking search action in review section
    $(document).on('click', '.pr-rd-search-reviews-icon-button', function () {
      if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
        var searchTerm = $(this).siblings(':input').val();

        if (searchTerm && searchTerm !== '') {
          var obj = {
            search_term: searchTerm
          };

          site.track.searchReviews(obj);
        }
      }
    });

    // Track read reviews in review page
    $(document).on('click', '.pr-snippet-review-count, .review-snippet__count', function () {
      if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
        site.track.reviewRead();
      }
    });

    // Track write reviews in review page
    $(document).on('click', '.pr-snippet-write-review-link', function () {
      if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
        site.track.reviewWriteStart();
      }
    });
  };
  var _reviewDisplayCallback = function (config, data, $template) {
    if (config.component === 'ReviewDisplay') {
      // Move top snippets block into the 3 col header
      var $snippets = $('.pr-review-snapshot-snippets', $template);

      $snippets.addClass('pr-review-snapshot-block');
      $('.pr-review-snapshot-block-container', $template).append($snippets);
    }
  };

  /*
   * Handle the ReviewSnippet click.
   */
  $(document).on('click', '.product-full .js-product-rating', function (e) {
    // Note that the spp-reviews exists outside of product-full. So we need to
    // grab the outer spp shell for context.
    var $rating = $(this);

    // WE only scroll down to reviews if we have some. Otherwise we show write
    // review link.
    if (!$rating.data('pr-has-reviews')) {
      return;
    }
    var $sppContent = $rating.closest('.js-spp-content');

    if ($sppContent.length === 0) {
      return;
    }

    var $sppReviews = $('.js-spp-reviews', $sppContent);

    if ($sppReviews.length === 0) {
      return;
    }

    e.preventDefault();
    $('html, body').animate(
      {
        scrollTop: $sppReviews.offset().top
      },
      500,
      function () {}
    );
  });

  // PR Q&A tabs feature constants
  const tabNavSelector = '.js-pr-tab-nav';
  const tabContentSelector = '.js-pr-tab-content';
  const tabIdAttr = 'data-tab';
  const activeTabClass = 'active';
  const hiddenContentClass = 'hidden';

  Drupal.behaviors.sppReviewsV1 = MantleBehavior.create({
    targetSelector: '.js-spp-reviews',

    attachTarget: function (target) {
      // Bail if Power Reviews not set up.
      if (!MantleReviews.power_reviews_enabled()) {
        return;
      }
      MantleReviews.set_auto(false);
    },

    /*
     * This is meant to be loaded after PR js is loaded async.
     */
    attachAfterPR: function (target) {
      var $template = $(target);
      var productId = $template.data('product-id');
      var product = prodcat.data.getProduct(productId);
      var productBaseId = product.PROD_BASE_ID;
      var skuBaseId = $template.data('sku-base-id');
      var pageId = productBaseId;
      var review_display_id =
        'spp-reviews-display-' +
        productBaseId +
        '-' +
        skuBaseId +
        '-' +
        '1' +
        '-' +
        new Date().getTime();
      var $review_display = $('.spp-reviews__content', $template);
      var pr_product = MantleReviews.get_base_pr_product();

      // Only bind reviews display once.
      if (!$review_display.length || $review_display.hasClass('reviews-processed')) {
        return;
      }

      // Add unique snippet identifier to snippet for reference.
      $review_display.attr('id', review_display_id);

      // Initialize product config.
      pr_product.page_id = pageId;
      pr_product.product_base_id = productId;

      pr_product.components.ReviewDisplay = 'spp-reviews-display';

      if(Drupal.settings.power_reviews.show_ask_question) {
        $('.js-pr-ask-tab', $template).removeClass('hidden');
        pr_product.components.QuestionSnippet = 'pr-questionsnippet';
        pr_product.components.QuestionDisplay = 'pr-questiondisplay';
      }

      pr_product.mantle_meta = {
        product_base_id: productBaseId,
        product_id: productId,
        add_product_info: true,
        add_product_variants: true,
        sort_attach_selectbox: true,
        sort_attach_selectbox_mobile: true,
        new_star_label: 'Heart',
        new_star_tooltip: 'heart',
        review_display_element: $template,
        search_placeholder: 'SEARCH REVIEWS'
      };

      pr_product.on_render = function (config, data) {
        _reviewDisplayCallback(config, data, $template);

        // Track sort option in reviews page
        $('#pr-rd-sort-by')
          .once()
          .on('change', function () {
            if (
              typeof site !== 'undefined' &&
              typeof site.track !== 'undefined' &&
              drupalPRSettings
            ) {
              var obj = {
                sort_option: $('option:selected', this).text()
              };

              site.track.sortReviews(obj);
            }
          });

        // Tracking filter action in review section
        $('.pr-filter-btn')
          .once('js-filter-review')
          .each(function () {
            $(this).on('click', function () {
              var checkSelected = $(this).hasClass('pr-filter-btn--active');

              if (
                typeof site !== 'undefined' &&
                typeof site.track !== 'undefined' &&
                !checkSelected &&
                drupalPRSettings
              ) {
                var filterElem = $(this);

                filterElem.attr('data-selected', 'selected');
                var selectedFilter = $('[data-selected="selected"]');
                var appliedFiltersArray = [];

                selectedFilter.each(function () {
                  appliedFiltersArray.push($(this).find('.pr-filter-btn__buttonText').text());
                });
                var obj = {
                  sort_option: appliedFiltersArray.join(', ')
                };

                site.track.filterReviews(obj);
              } else if (checkSelected) {
                $(this).attr('data-selected', 'deselected');
              }
            });
          });
        initQnATabsBehavior();
      };

      _attachReviewsAnalytics(drupalPRSettings);

      MantleReviews.add_pr_product(pr_product);
      // Callback for Reviews is heavy. Delay for now. Would prefer to make
      // this 100% lazy but need PR for snippets currently
      MantleReviews.setMinimumTimeout(1000);
      MantleReviews.renderAsync();
    },

    attachLazyTarget: function (target) {
      if (!window.MantleReviews || _.isUndefined(Drupal.settings.power_reviews)) {
        return;
      }

      // Bail if Power Reviews not set up.
      if (!MantleReviews.power_reviews_enabled()) {
        return;
      }
      var mod = this;

      MantleReviews.loadPRJS(function () {
        mod.attachAfterPR(target);
      });
    }
  });

  const initQnATabsBehavior = () => {
    // PR tabs elements
    const $tabNavs = $(tabNavSelector);
    const $tabsContent = $(tabContentSelector);

    // PR tabs handler
    $tabNavs.once().on('click', (e) => {
      const $tab = $(e.target);
      const tabId = $tab.attr(tabIdAttr);
      const targetTabContentSelector = `.${tabId}`;

      // Reset tabs and content
      $tabNavs.removeClass(activeTabClass);
      $tabsContent.addClass(hiddenContentClass);
      // Activate target tab and its content
      $tab.addClass(activeTabClass);
      $(targetTabContentSelector).removeClass(hiddenContentClass);
    });
  };
})(jQuery);
